<template>
  <div>
    <template v-if="loading || parentLoading">
      <v-skeleton-loader
        v-for="n in 3"
        :key="n"
        type="list-item"
      />
    </template>

    <v-alert
      v-else-if="error"
      type="error"
      dense
      text
    >
      Impossible de charger les avantages
    </v-alert>

    <v-alert
      v-else-if="perks.length === 0"
      type="info"
      dense
      text
    >
      Aucun avantage disponible pour le moment
    </v-alert>

    <template v-else>
      <v-switch
        v-for="perk in perks"
        :key="perk.uuid"
        :input-value="value?.includes(perk.uuid)"
        :label="perk.name"
        :disabled="readOnly"
        hide-details
        inset
        class="mt-2"
        @change="toggle(perk.uuid, $event)"
      />
    </template>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from 'vue';
import PerksService from '@/services/PerksService';

const emit = defineEmits(['input']);

const props = defineProps({
  value: {
    type: Array,
    default: () => []
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  parentLoading: {
    type: Boolean,
    default: false
  }
});

const perks = ref([]);
const loading = ref(true);
const error = ref(false);

onMounted(async () => {
  const response = await PerksService.getPerks();

  if (response.success) {
    perks.value = response.data || [];
  } else {
    error.value = true;
  }

  loading.value = false;
});

const toggle = (uuid, isOn) => {
  const current = props.value || [];
  const updated = isOn
    ? [...current, uuid]
    : current.filter(id => id !== uuid);

  emit('input', updated);
};
</script>
